import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { classNameTriskeleParser } from '../../../utilities/customStyles';
import { List, ListItem } from '@mui/material';

const UserProfileSkeleton = () => (
  <div>
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <div className={`clinician-profile-card ${classNameTriskeleParser('Background', 'Faded Navy', 'Rectangle')}`}>
        <div style={{
          position: 'relative', width: '100%', display: 'flex', justifyContent: 'center'
        }}>


          <div style={{ margin: '10px' }}>
            <Skeleton borderRadius="50%" height="70px" width="70px" margin="0" />
          </div>
        </div>
        <Skeleton borderRadius="10px" height="15px" width="40vw" margin="0" />
        <Skeleton borderRadius="10px" height="15px" width="20vw" margin="0" />
      </div>


      {[...Array(6)].map((row, i) => (

        <ListItem key={i} style={{ paddingTop: 0, position: 'relative', top: i !== 0 ? '-10px' : '-5px' }}>
          <div className="column-flex" style={{ marginLeft: '10px' }}>
            <Skeleton borderRadius="10px" height="15px" width="40vw" margin="0" />
            <Skeleton borderRadius="10px" height="15px" width="25vw" margin="0" style={{ alignItems: 'center' }} />
          </div>
        </ListItem>
      ))}

    </List>


  </div>


);
export default UserProfileSkeleton;
